import { useCallback, useEffect, useState } from 'react';
import type { AdminOrganizationDetail } from '../../../domain/superadmin/types';
import { useAppContext } from '../../../contexts/AppContext';
import { fetchAdminOrganizationDetail } from '../../../services/modules/superadmin/superadminApi';
import { SuperadminApiError } from '../../../services/modules/superadmin/errors';
import { notify } from '../../../utils/toast';

export function useAdminOrganizationDetail() {
  const { superadminOrgId, setCurrentPage } = useAppContext();
  const orgId = superadminOrgId;

  const [data, setData] = useState<AdminOrganizationDetail | null>(null);
  const [isLoading, setIsLoading] = useState(Boolean(orgId));
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!orgId) {
      setData(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const result = await fetchAdminOrganizationDetail(orgId);
      setData(result);
    } catch (e) {
      if (e instanceof SuperadminApiError && e.isForbidden) {
        setCurrentPage('dashboard');
        notify.warning('Acesso não autorizado à área de superadmin.');
        return;
      }
      setError(e instanceof Error ? e.message : 'Erro ao carregar empresa');
    } finally {
      setIsLoading(false);
    }
  }, [orgId, setCurrentPage]);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    data,
    isLoading,
    error,
    refetch: load,
    orgId,
  };
}
